"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = Modal;
const React = __importStar(require("react"));
const react_modal_1 = __importDefault(require("react-modal"));
const customStyles = {
    content: {
        top: '0',
        left: '0',
        height: '100%',
        margin: 'auto',
        padding: '0',
        overflow: 'hidden',
        width: '100%',
        position: 'fixed',
        backgroundColor: 'transparent',
        border: 'none',
    },
    overlay: {
        backgroundColor: 'rgba(100, 100, 100, 0.75)',
    },
};
function Modal(props) {
    const renderHeader = () => {
        const { renderHeader } = props;
        if (!renderHeader)
            return null;
        return React.createElement("div", { className: "Modal-header" }, renderHeader());
    };
    const renderFooter = () => {
        const { renderFooter } = props;
        if (!renderFooter)
            return null;
        return React.createElement("div", { className: "Modal-footer" }, renderFooter());
    };
    const { contentLabel, onAfterOpen, hide, children } = props;
    return (React.createElement(react_modal_1.default, { isOpen: true, style: customStyles, onAfterOpen: onAfterOpen, contentLabel: contentLabel },
        React.createElement("div", { className: "Modal is-open is-active" },
            React.createElement("div", { className: "Modal-content" },
                React.createElement("div", { style: { position: 'absolute', right: '0px', top: '15px' } },
                    React.createElement("i", { className: "Feedback-dismiss", onClick: hide },
                        React.createElement("svg", { viewBox: "0 0 960 960", role: "presentation", className: "Icon" },
                            React.createElement("path", { d: "M628 480l189 190c8.7 8 13.7 17.5 15 28.5s-1.3 20.2-8 27.5c-28.7 36.7-61.3 69.3-98 98-7.3 6.7-16.5 9.3-27.5 8s-20.8-6-29.5-14L480 628 290 818c-8 8-17.5 12.7-28.5 14s-20.5-1.3-28.5-8c-36-28.7-68.3-61-97-97-6.7-8-9.3-17.5-8-28.5 1.3-11 6-20.5 14-28.5l190-190-189-189c-8.7-8.7-13.7-18.5-15-29.5-1.3-11 1.3-20.2 8-27.5 28-36 60.3-68.7 97-98 8-6.7 17.5-9.3 28.5-8s20.5 6.3 28.5 15l190 181 189-181c8.7-8.7 18.5-13.7 29.5-15s20.2 1.3 27.5 8c36.7 28.7 69.3 61.3 98 98 6.7 7.3 9.3 16.5 8 27.5s-6.3 20.8-15 29.5L628 480z" })))),
                renderHeader(),
                React.createElement("div", { className: "Modal-body" }, children),
                renderFooter()))));
}
